import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ValueEncoder } from "../Utils/ValueEncoder";

export class SmtpSettings implements ObjectSerializer {

	public ServerAddress: string;
	public ServerPort: number;
	public Timeout: number;
	public ToAddress: string;
	public FromAddress: string;
	public FromName: string;
	public UserName: string;
	public Password: string;
	public RequiresAuth: boolean;
	public RequiresEncryption: boolean;

	public get HasServerAddress(): boolean {
		return !!this.ServerAddress;
	}

	public get HasToAddress(): boolean {
		return !!this.ToAddress;
	}

	constructor() {
		this.Clear();
	}

	private Clear(): void {
		this.ServerAddress = "";
		this.ServerPort = 25;
		this.Timeout = 10000;
		this.ToAddress = "recipient@domain.com";
		this.FromAddress = "sender@domain.com";
		this.FromName = "";
		this.Password = "";
		this.UserName = "";
		this.RequiresEncryption = false;
		this.RequiresAuth = false;
	}

	public get IsValid(): boolean {
		if (!this.ServerAddress) {
			return false;
		}
		if (this.ServerPort < 0) {
			return false;
		}
		if (this.Timeout < 0) {
			return false;
		}
		if (!this.ToAddress) {
			return false;
		}
		if (!this.FromAddress) {
			return false;
		}
		if (!this.FromName) {
			return false;
		}

		return true;
	}

	public Write(obj: any, context: any): void {
		obj.smtp_settings = {};
		obj = obj.smtp_settings;

		obj.server_address = this.ServerAddress;
		obj.server_port = ValueEncoder.EncodeInteger(this.ServerPort);
		obj.timeout = ValueEncoder.EncodeInteger(this.Timeout);
		obj.to_address = this.ToAddress;
		obj.from_address = this.FromAddress;
		obj.from_name = this.FromName;
		obj.requires_auth = ValueEncoder.EncodeBoolean(this.RequiresAuth);
		obj.user_name = this.UserName;
		obj.password = this.Password;
		obj.requires_encryption = ValueEncoder.EncodeBoolean(this.RequiresEncryption);
	}

	public Read(obj: any, context: any): void {
		if (!obj.smtp_settings)
			throw new Error();
		obj = obj.smtp_settings;

		if (obj.server_address !== undefined)
			this.ServerAddress = obj.server_address;

		if (obj.server_port !== undefined)
			this.ServerPort = ValueEncoder.DecodeInteger(obj.server_port);

		if (obj.timeout !== undefined)
			this.Timeout = ValueEncoder.DecodeInteger(obj.timeout);

		if (obj.to_address !== undefined)
			this.ToAddress = obj.to_address;

		if (obj.from_address !== undefined)
			this.FromAddress = obj.from_address;

		if (obj.from_name !== undefined)
			this.FromName = obj.from_name;

		if (obj.requires_auth !== undefined)
			this.RequiresAuth = ValueEncoder.DecodeBoolean(obj.requires_auth);

		if (obj.user_name !== undefined)
			this.UserName = obj.user_name;

		if (obj.password !== undefined)
			this.Password = obj.password;

		if (obj.requires_encryption !== undefined)
			this.RequiresEncryption = ValueEncoder.DecodeBoolean(obj.requires_encryption);
	}

}